/* Dispatch cut-off and offer deadline countdowns.
   Both are driven by values configured in the theme editor. The cut-off rolls
   forward to the next day once it passes; the deadline removes itself when it
   expires rather than looping, so neither can imply pressure that isn't real. */
(() => {
  if (window.cloudUrgencyBound) return;
  window.cloudUrgencyBound = true;

  const pad = (n) => String(n).padStart(2, '0');

  const humanise = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(total / 86400);
    const h = Math.floor((total % 86400) / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    if (d > 0) return `${d}d ${pad(h)}h ${pad(m)}m`;
    if (h > 0) return `${h}h ${pad(m)}m ${pad(s)}s`;
    return `${m}m ${pad(s)}s`;
  };

  const tickCutoff = (el) => {
    const hour = parseInt(el.dataset.cutoffHour, 10);
    const minute = parseInt(el.dataset.cutoffMinute, 10) || 0;
    if (Number.isNaN(hour)) return;

    const now = new Date();
    const target = new Date(now);
    target.setHours(hour, minute, 0, 0);

    let label = el.dataset.labelToday || 'Order within [time] for dispatch today';
    if (target <= now) {
      target.setDate(target.getDate() + 1);
      label = el.dataset.labelTomorrow || 'Order within [time] for dispatch tomorrow';
    }

    const text = el.querySelector('[data-cloud-cutoff-text]');
    if (text) text.textContent = label.replace('[time]', humanise(target - now));
    el.hidden = false;
  };

  const tickDeadline = (el) => {
    const end = new Date(el.dataset.deadline);
    if (Number.isNaN(end.getTime())) return;

    const remaining = end - new Date();
    if (remaining <= 0) {
      el.remove();
      return;
    }

    const text = el.querySelector('[data-cloud-deadline-text]');
    const label = el.dataset.label || 'Offer ends in [time]';
    if (text) text.textContent = label.replace('[time]', humanise(remaining));
    el.hidden = false;
  };

  /* Announcement-bar clock. Same honest rules as the strips above: it counts to
     the real dispatch cut-off, or to a genuine offer end date when one is set,
     and removes itself once that date passes rather than looping. */
  const tickBar = (el) => {
    let remaining;

    if (el.dataset.deadline) {
      const end = new Date(el.dataset.deadline);
      if (Number.isNaN(end.getTime())) return;
      remaining = end - new Date();
      if (remaining <= 0) {
        el.remove();
        return;
      }
    } else {
      const hour = parseInt(el.dataset.cutoffHour, 10);
      if (Number.isNaN(hour)) return;
      const minute = parseInt(el.dataset.cutoffMinute, 10) || 0;
      const now = new Date();
      const target = new Date(now);
      target.setHours(hour, minute, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      remaining = target - now;
    }

    const total = Math.max(0, Math.floor(remaining / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const sec = total % 60;

    const set = (key, value) => {
      const node = el.querySelector(`[data-cc-${key}]`);
      if (node && node.textContent !== value) node.textContent = value;
    };
    set('h', pad(h));
    set('m', pad(m));
    set('s', pad(sec));

    const a11y = el.querySelector('[data-cc-a11y]');
    if (a11y) a11y.textContent = `${h} hours ${m} minutes remaining`;
  };

  const tick = () => {
    document.querySelectorAll('[data-cloud-cutoff]').forEach(tickCutoff);
    document.querySelectorAll('[data-cloud-deadline]').forEach(tickDeadline);
    document.querySelectorAll('[data-cloud-bar-countdown]').forEach(tickBar);
  };

  const start = () => {
    tick();
    setInterval(tick, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
